import React from 'react';
import Form from 'react-bootstrap/Form';


class FormField extends React.Component {
  render() {
    var fieldProps = {
      name: this.props.name,
      type: this.props.type,
      id: this.props.id,
      value: this.props.value,
      onChange: this.props.onChange,
      required: this.props.required,
      placeholder: this.props.placeholder
    };
    var helpText;
    var feedback;

    if (this.props.inputRef) {
      fieldProps.ref = this.props.inputRef;
    }

    if (this.props.helpText) {
      helpText = (
        <Form.Text className="text-muted">
          {this.props.helpText}
        </Form.Text>
      );
    }

    if (this.props.validated) {
      if (this.props.validationMessage) {
        fieldProps.isInvalid = true;
        feedback = (
          <Form.Control.Feedback type="invalid">{this.props.validationMessage}</Form.Control.Feedback>
        );
      } else {
        fieldProps.isValid = true;
      }
    }


    return (
      <Form.Group>
        <Form.Label htmlFor={this.props.id}>{this.props.label}</Form.Label>
        <Form.Control {...fieldProps} />
        {feedback}
        {helpText}
      </Form.Group>
    );
  }
}


export default FormField;

